<template>
    <div class="animated fadeIn">
        <b-container class="w-100 px-0">
            <b-row class="m-0 py-2 px-2 w-100">
                <b-form @submit.prevent="store" enctype="multipart/form-data">
                    <b-row class="bg-light m-0 p-3">
                        <b-row class="w-100 px-2 pb-3">
                            <b-col md="6">
                                <!-- ////////////////////// IBAN ////////////////////// !-->
                                <b-form-group
                                    :label="labels.iban"
                                    label-for="iban"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <b-form-input
                                        id="iban"
                                        name="iban"
                                        type="text"
                                        placeholder="Cuenta Bancaria"
                                        v-model="entity.iban"
                                        class="w-100"
                                        v-validate="'iban'"
                                        :state="validateState('iban')"
                                        aria-describedby="check_iban"></b-form-input>
                                    <div class="text-danger text-right" id="check_iban">
                                        <small>{{ errors.first('iban') }}</small>
                                    </div>
                                </b-form-group>
                                <!-- !-->
                            </b-col>
                            <b-col md="6">
                                <!-- ////////////////////// Entidad ////////////////////// !-->
                                <b-form-group
                                    :label="labels.bankName"
                                    label-for="bankName"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <b-form-input
                                        id="bankName"
                                        name="bankName"
                                        type="text"
                                        placeholder="Entidad"
                                        v-model="entity.bankName"
                                        v-validate="'min:3'"
                                        :state="validateState('bankName')"
                                        aria-describedby="check_bankName"></b-form-input>
                                    <div class="text-danger text-right" id="check_bankName">
                                        <small>{{ errors.first('bankName') }}</small>
                                    </div>
                                </b-form-group>
                                <!-- !-->
                            </b-col>
                        </b-row>

                        <b-row class="w-100 px-2 pb-3">
                            <b-col md="6">
                                <!-- ////////////////////// Convenio ////////////////////// !-->
                                <b-form-group
                                    label="<strong>Convenio</strong>"
                                    label-for="agreement"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <fee-agreement-selector
                                        v-model="feeAgreement"
                                        id="agreement"
                                        :headquartersId="entity.headquartersId"
                                        :allowEmpty="true"></fee-agreement-selector>
                                </b-form-group>
                                <!-- !-->
                            </b-col>
                        </b-row>

                        <b-row class="w-100 px-2 pb-3">
                            <b-col md="4">
                                <!-- ////////////////////// Forma de Pago ////////////////////// !-->
                                <b-form-group
                                    label="<strong>Forma de Pago *</strong>"
                                    label-for="paymentMethod"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <payment-method-selector v-model="entity.paymentMethod"></payment-method-selector>
                                </b-form-group>
                                <!-- !-->
                            </b-col>
                            <b-col md="4">
                                <!-- ////////////////////// Tipo de Cuota ////////////////////// !-->
                                <b-form-group
                                    label="<strong>Tipo de Cuota *</strong>"
                                    label-for="feeTypeId"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <multiselect
                                        name="feeTypeId"
                                        v-model="entity.feeTypeId"
                                        :options="feeTypes.map(type => type.uuid)"
                                        :custom-label="opt => feeTypes.find(x => x.uuid == opt).name"
                                        :multiple="false"
                                        :allowEmpty="false"
                                        placeholder="Seleccione"
                                        selectedLabel=""
                                        selectLabel="+"
                                        deselectLabel="-"
                                        v-if="feeTypes.length > 0">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{ getFeeTypeLabel(props.option) }}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            {{ getFeeTypeLabel(props.option) }}
                                        </template>
                                    </multiselect>
                                </b-form-group>
                                <!-- !-->

                            </b-col>
                            <b-col md="4">
                                <!-- ////////////////////// Importe ////////////////////// !-->
                                <b-form-group
                                    label="&nbsp"
                                    label-for="amount"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <div class=" text-right mt-1" id="check_amount">
                                        <input type="checkbox" v-model="entity.exemptFromPayment"/> Exento de pago
                                    </div>
                                </b-form-group>
                                <!-- !-->
                            </b-col>
                        </b-row>

                        <b-row class="w-100 px-2 pb-1">
                            <b-col md="4">
                                <!-- ////////////////////// Pagado Hasta ////////////////////// !-->
                                <b-form-group
                                    label="<strong>Pagado Hasta</strong>"
                                    label-for="paidUntil"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <v-date-picker v-model='entityPaidUntilFormatted' :max-date="new Date()" popoverDirection="top">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <b-form-input
                                                :value="inputValue"
                                                v-on="inputEvents"
                                                id="paidUntil"
                                                name="paidUntil"
                                                class="w-100"
                                                v-validate="{required: true, paidUntil: {birthday: entity.birthday}}"
                                                :state="validateState('paidUntil')"
                                                aria-describedby="check_paidUntil" />
                                        </template>
                                    </v-date-picker>
                                    <div class="text-danger text-right" id="check_paidUntil">
                                        <small>{{ errors.first('paidUntil') }}</small>
                                    </div>
                                </b-form-group>
                                <!-- !-->
                            </b-col>
                            <b-col md="4">
                                <!-- ////////////////////// Fecha Emisión Recibo ////////////////////// !-->
                                <b-form-group
                                    label="<strong>Fecha de Emisión de Recibo *</strong>"
                                    label-for="receiptIssueDate"
                                    :horizontal="false"
                                    class="w-100 mb-0">
                                    <receipt-issue-date-selector
                                        id="receiptIssueDate"
                                        v-model="entity.receiptIssueDate"></receipt-issue-date-selector>
                                </b-form-group>
                                <!-- !-->
                            </b-col>
                        </b-row>
                    </b-row>
                    <b-row class="pt-4 m-0 pb-0">
                        <div class="px-0 col float-left">
                            <button
                                v-if="mixinCheckPermission('EDIT_MEMBER_BANK_DATA')"
                                type="submit"
                                class="btn btn-brand btn-primary btn-lg pull-right"
                                :disabled="!validate()">Guardar
                            </button>
                        </div>
                    </b-row>
                </b-form>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import {request} from '@/helpers/services';
    import Multiselect from 'vue-multiselect';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import PaymentMethodSelector from '@/components/clients/members/PaymentMethodSelector';
    import ReceiptIssueDateSelector from '@/components/clients/members/ReceiptIssueDateSelector';
    import feeAgreementSelector from '@/components/agreements/FeeAgreementSelector';
    import moment from 'moment';

    import 'v-calendar/lib/v-calendar.min.css';

    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });

    export default {
        name: 'addPartners',
        components: {
            'v-date-picker': DatePicker,
            Multiselect,
            PaymentMethodSelector,
            ReceiptIssueDateSelector,
            feeAgreementSelector
        },
        props: [
            'partner',
            'headquarters',
            'feeTypes'
        ],
        data: function () {
            return {
                topmenu: [
                    {name: 'Volver', path: '/admin/agreements/list', brand: 'fa fa-arrow-left'},
                ],
                title: 'Nuevo Socio',
                subtitle: 'Paso 3 de 4',
                entity: {
                    iban: '',
                    bankName: '',
                    agreementId: null,
                    paymentMethod: '',
                    feeTypeId: null,
                    amount: 0,
                    exemptFromPayment: false,
                    paidUntil: null,
                    receiptIssueDate: null,
                    headquartersId: null
                },
                feeAgreement: {
                    uuid: this.partner.agreementId
                },
                today: null,
                charge_label: "Comprobando NIF...",
                strings: ['paymentMethod', 'feeTypeId', 'receiptIssueDate'],
                arrays: [],
                labels: {
                    iban: '<strong>IBAN</strong>',
                    bankName: '<strong>Entidad</strong>'
                }
            }
        },
        computed: {
            entityPaidUntilFormatted: {
                get() {
                    return this.entity.paidUntil && new Date(this.entity.paidUntil)
                },
                set(newValue) {
                    this.entity.paidUntil = moment(newValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            },
        },
        mounted() {
            this.entity = Object.assign({}, this.entity, this.partner);
            if (this.entity.paidUntil) {
                this.entity.paidUntil = moment(this.entity.paidUntil).format('YYYY-MM-DD');
            }
            this.today = new Date();
        },
        methods: {
            checkPaymentMethod() {
                if (this.entity.paymentMethod == 'BANK') {
                    this.strings.push('iban', 'bankName');
                    this.labels.iban = '<strong>IBAN *</strong>';
                    this.labels.bankName = '<strong>Entidad *</strong>';
                }
                else {
                    var i;
                    i = this.strings.indexOf('iban');
                    this.strings.splice(i, 1);
                    i = this.strings.indexOf('bankName');
                    this.strings.splice(i, 1);
                    this.labels.iban = '<strong>IBAN</strong>';
                    this.labels.bankName = '<strong>Entidad</strong>';
                }
            },
            getFeeTypeLabel(feeTypeUuid) {
                let feeType = this.feeTypes.find(feeType => feeType.uuid === feeTypeUuid);
                return `${feeType.name} - ${feeType.amount}€`;
            },
            store() {
                this.$_loadingMixin_showLoading();
                let self = this;
                try {
                    request('/members/' + this.partner.uuid + '/steps/3', 'post', 200, this.entity).then(x => {
                        self.setPartner(x);
                        self.$_loadingMixin_hideLoading();
                    });
                } catch (error) {
                    console.log(error, "<--");
                }
            },
            async requests(path, method, okCode, entity) {
                this[entity] = await request(path, method, okCode);
            },
            validate() {
                if (this.strings.filter(string => !this.entity[string]).length > 0) {
                    return false;
                }
                if (this.arrays.filter(array => this.entity[array].length == 0).length > 0) {
                    return false;
                }
                if (this.errors.items.length > 0) {
                    return false;
                }
                return true;

            },
            setPartner(entity) {
                this.$emit('sendPartner', entity);
            }
        },
        watch: {
            'feeAgreement.uuid': function () {
                this.entity.agreementId = this.feeAgreement.uuid
                    ? this.feeAgreement.uuid
                    : null;
            }
        }
    }
</script>
